module.exports = __webpack_public_path__ + "static/media/YF44_3.5a5f42b3.jpg";